import moment from 'moment';


class Horoscope {
    getZodiac(date) {
        const zodiacDate = [
            {
                'zoc' : 'aquarius',
                'start' : moment('19/01', "DD/MM"),
                'end' : moment('19/02', "DD/MM"),
            },
            {
                'zoc' : 'pisces',
                'start' : moment('18/02', "DD/MM"),
                'end' : moment('21/03', "DD/MM"),
            },
            {
                'zoc' : 'aries',
                'start' : moment('20/03', "DD/MM"),
                'end' : moment('20/04', "DD/MM"),
            },
            {
                'zoc' : 'taurus',
                'start' : moment('19/04', "DD/MM"),
                'end' : moment('21/05', "DD/MM"),
            },
            {
                'zoc' : 'gemini',
                'start' : moment('20/05', "DD/MM"),
                'end' : moment('21/06', "DD/MM"),
            },
            {
                'zoc' : 'cancer',
                'start' : moment('20/06', "DD/MM"),
                'end' : moment('23/07', "DD/MM"),
            },
            {
                'zoc' : 'leo',
                'start' : moment('22/07', "DD/MM"),
                'end' : moment('23/08', "DD/MM"),
            },
            {
                'zoc' : 'virgo',
                'start' : moment('22/08', "DD/MM"),
                'end' : moment('23/09', "DD/MM"),
            },
            {
                'zoc' : 'libra',
                'start' : moment('22/09', "DD/MM"),
                'end' : moment('23/10', "DD/MM"),
            },
            {
                'zoc' : 'scorpio',
                'start' : moment('22/10', "DD/MM"),
                'end' : moment('22/11', "DD/MM"),
            },
            {
                'zoc' : 'sagitarius',
                'start' : moment('21/11', "DD/MM"),
                'end' : moment('22/12', "DD/MM"),
            },
            {
                'zoc' : 'capricorn',
                'start' : moment('21/12', "DD/MM"),
                'end' : moment('32/12', "DD/MM"),
            },
            {
                'zoc' : 'capricorn',
                'start' : moment('01/01', "DD/MM"),
                'end' : moment('20/01', "DD/MM"),
            },
        ]

        const formatDate = moment(date, "YYYY-MM-DD").format('DD/MM');
        const birthDate = moment(formatDate, "DD/MM");

        if (birthDate.isBetween(zodiacDate[0].start, zodiacDate[0].end)) {
            return 'Aquarius';
        }
        if (birthDate.isBetween(zodiacDate[1].start, zodiacDate[1].end)) {
            return 'Pisces';
        }
        if (birthDate.isBetween(zodiacDate[2].start, zodiacDate[2].end)) {
            return 'Aries';
        }
        if (birthDate.isBetween(zodiacDate[3].start, zodiacDate[3].end)) {
            return 'Taurus';
        }
        if (birthDate.isBetween(zodiacDate[4].start, zodiacDate[4].end)) {
            return 'Gemini';
        }
        if (birthDate.isBetween(zodiacDate[5].start, zodiacDate[5].end)) {
            return 'Cancer';
        }
        if (birthDate.isBetween(zodiacDate[6].start, zodiacDate[6].end)) {
            return 'Leo';
        }
        if (birthDate.isBetween(zodiacDate[7].start, zodiacDate[7].end)) {
            return 'Virgo';
        }
        if (birthDate.isBetween(zodiacDate[8].start, zodiacDate[8].end)) {
            return 'Libra';
        }
        if (birthDate.isBetween(zodiacDate[9].start, zodiacDate[9].end)) {
            return 'Scorpio';
        }
        if (birthDate.isBetween(zodiacDate[10].start, zodiacDate[10].end)) {
            return 'Sagitarius';
        }
        if (birthDate.isSame(moment('01/01', "DD/MM")) || birthDate.isBetween(zodiacDate[11].start, zodiacDate[11].end) || birthDate.isBetween(zodiacDate[12].start, zodiacDate[12].end)) {
            return 'Capricorn';
        }
    }

    getShioYear() {
        const yearStart = 1924;
        const yearEnd = moment().year();
        const delta = Math.floor((yearEnd - yearStart) / 8);
        let shio = [
            {
                'name': 'tikus',
                'start': 1924,
                'year': []
            },
            {
                'name': 'kerbau',
                'start': 1925,
                'year': []
            },
            {
                'name': 'macan',
                'start': 1926,
                'year': []
            },
            {
                'name': 'kelinci',
                'start': 1927,
                'year': []
            },
            {
                'name': 'naga',
                'start': 1928,
                'year': []
            },
            {
                'name': 'ular',
                'start': 1929,
                'year': []
            },
            {
                'name': 'kuda',
                'start': 1930,
                'year': []
            },
            {
                'name': 'kambing',
                'start': 1931,
                'year': []
            },
            {
                'name': 'monyet',
                'start': 1932,
                'year': []
            },
            {
                'name': 'ayam',
                'start': 1933,
                'year': []
            },
            {
                'name': 'anjing',
                'start': 1934,
                'year': []
            },
            {
                'name': 'babi',
                'start': 1935,
                'year': []
            },
        ];

        shio.forEach(element => {
            for (let i = element.start; i <= yearEnd; i = i + delta) {
                element.year.push(i.toString());
            }
        });

        return shio;
    }
}

export default new Horoscope();
